/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type McpConnection = {
  id: number;
  secretId: string;
  authenticatorId: string;
  authType: McpServerAuthType;
  portalId: number;
  userId: number;
  mcpServerId: number;
  unifiedAccountId?: number;
};

export type McpConnectionByIdRequest = { id: number };

export type McpConnectionByServerIdRequest = { mcpServerId: number };

export type McpConnectionCreateRequest = {
  mcpServerId: number;
  secretId: string;
};

export type McpConnectionCreateWithUnifiedAccountRequest = {
  mcpServerId: number;
  unifiedAccountId: number;
};

export type McpConnectionDeleteRequest = { id: number };

export type McpConnectionsListRequest = {};

export type McpSecretDeleteRequest = { mcpServerId: number; secretId: string };

export type McpConnectionDeleteResponse = { deleted: boolean };

export type McpConnectionResponse = { mcpConnection?: McpConnection };

export type McpConnectionsListResponse = {
  connections: Default<McpConnection[]>;
};

export type McpSecretDeleteResponse = { deleted: boolean };

export type McpRegistryError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType =
  | 'INSERT_ERROR'
  | 'UPDATE_ERROR'
  | 'DELETE_ERROR'
  | 'INVALID_REQUEST'
  | 'NOT_FOUND'
  | 'UNAUTHORIZED'
  | 'USER_ID_NOT_SUPPLIED'
  | 'PORTAL_ID_NOT_SUPPLIED'
  | 'VENDOR_AUTHORIZATION_FAILED'
  | 'VENDOR_CONNECTION_FAILED'
  | unhandledEnumCase;

export type McpServerAuthType =
  | 'OAUTH2'
  | 'URL_BASED'
  | 'OAUTH2_DYNAMIC_URL'
  | unhandledEnumCase;

export type RegisterRequestType = Requestify<McpConnectionCreateRequest>;
export type RegisterResponseType = McpConnectionResponse;
export type RegisterErrorType = McpRegistryError & HubspotMetadata;
export const registerRpc: ChirpAvroRpcDetails<
  RegisterRequestType,
  RegisterResponseType,
  RegisterErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'register',
  auth: 'app',
  fingerprint: 'eif_VDrf7eChOCCvb2HicskRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RegisterWithUnifiedAccountRequestType =
  Requestify<McpConnectionCreateWithUnifiedAccountRequest>;
export type RegisterWithUnifiedAccountResponseType = McpConnectionResponse;
export type RegisterWithUnifiedAccountErrorType = McpRegistryError &
  HubspotMetadata;
export const registerWithUnifiedAccountRpc: ChirpAvroRpcDetails<
  RegisterWithUnifiedAccountRequestType,
  RegisterWithUnifiedAccountResponseType,
  RegisterWithUnifiedAccountErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'registerWithUnifiedAccount',
  auth: 'app',
  fingerprint: 'DikgfhuioFyhOCCvb2HicskRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchByIdRequestType = Requestify<McpConnectionByIdRequest>;
export type FetchByIdResponseType = McpConnectionResponse;
export type FetchByIdErrorType = McpRegistryError & HubspotMetadata;
export const fetchByIdRpc: ChirpAvroRpcDetails<
  FetchByIdRequestType,
  FetchByIdResponseType,
  FetchByIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'fetchById',
  auth: 'app',
  fingerprint: 'TyA0SEBahAahOCCvb2HicskRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchByMcpServerIdRequestType =
  Requestify<McpConnectionByServerIdRequest>;
export type FetchByMcpServerIdResponseType = McpConnectionsListResponse;
export type FetchByMcpServerIdErrorType = McpRegistryError & HubspotMetadata;
export const fetchByMcpServerIdRpc: ChirpAvroRpcDetails<
  FetchByMcpServerIdRequestType,
  FetchByMcpServerIdResponseType,
  FetchByMcpServerIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'fetchByMcpServerId',
  auth: 'app',
  fingerprint: '9Mhq221VUjnT3S3TPqhfAMkRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteRequestType = Requestify<McpConnectionDeleteRequest>;
export type DeleteResponseType = McpConnectionDeleteResponse;
export type DeleteErrorType = McpRegistryError & HubspotMetadata;
export const deleteRpc: ChirpAvroRpcDetails<
  DeleteRequestType,
  DeleteResponseType,
  DeleteErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: 'nMaDJsz3WlO4SzFpk2_xw8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteSecretRequestType = Requestify<McpSecretDeleteRequest>;
export type DeleteSecretResponseType = McpSecretDeleteResponse;
export type DeleteSecretErrorType = McpRegistryError & HubspotMetadata;
export const deleteSecretRpc: ChirpAvroRpcDetails<
  DeleteSecretRequestType,
  DeleteSecretResponseType,
  DeleteSecretErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'deleteSecret',
  auth: 'app',
  fingerprint: 'nYAOSbWp6MWUsQ3BKKUq8skRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListConnectionsRequestType = Requestify<McpConnectionsListRequest>;
export type ListConnectionsResponseType = McpConnectionsListResponse;
export type ListConnectionsErrorType = McpRegistryError & HubspotMetadata;
export const listConnectionsRpc: ChirpAvroRpcDetails<
  ListConnectionsRequestType,
  ListConnectionsResponseType,
  ListConnectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpConnectionRegistryRpc',
  rpcName: 'listConnections',
  auth: 'app',
  fingerprint: '7iLmQiuuAv_T3S3TPqhfAMkRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
